import { cabecalhoIconeExportarRelatorioStyles } from './CabecalhoIconeExportarRelatorio.style'

export function cabecalhoIconeExportarRelatorioIO() {
  return {
    styles: cabecalhoIconeExportarRelatorioStyles
  }
}

export type CabecalhoIconeExportarRelatorioIO = ReturnType<typeof cabecalhoIconeExportarRelatorioIO>
